/**
 * @module interface
 */
export interface V2TimGroupChangeInfo {
    type?: number;
    value?: string;
    key?: string;
    boolValue?: Boolean;
}
